export const screenshots = [
    {
        id: 1,
        src: '/screenshots/1.png',
        alt: 'Home Screen'
    },
    {
        id: 2,
        src: '/screenshots/2.png',
        alt: 'Side Bar'
    },
    {
        id: 3,
        src: '/screenshots/3.png',
        alt: 'Switching'
    },
    {
        id: 4,
        src: '/screenshots/4.png',
        alt: 'Announcement'
    },
    {
        id: 5,
        src: '/screenshots/5.png',
        alt: 'Schedule'
    },
    {
        id: 6,
        src: '/screenshots/6.png',
        alt: 'Evaluations'
    },
    {
        id: 7,
        src: '/screenshots/7.png',
        alt: 'CMS'
    },
    {
        id: 8,
        src: '/screenshots/8.png',
        alt: 'Grades'
    },
    {
        id: 9,
        src: '/screenshots/9.png',
        alt: 'Calculator'
    },
    {
        id: 10,
        src: '/screenshots/10.png',
        alt: 'Pink Theme'
    }
];
